export default __webpack_public_path__ + "static/media/smlsoul.934086f3.png";